import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { NgxImageGalleryComponent, GALLERY_IMAGE, GALLERY_CONF } from 'ngx-image-gallery';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiService } from 'src/app/services/api/api.service';
import { MarketplaceService } from 'src/app/services/marketplace/marketplace';
import { ModalService } from '../modal.service';
import { CoreTranslateService } from 'src/app/services/utilitys/utilitys.service';

@Component({
  selector: 'app-modal-market-product-add',
  templateUrl: './modal-market-product-add.component.html',
  styleUrls: ['./modal-market-product-add.component.scss']
})
export class ModalMarketProductAddComponent implements OnInit {

  @ViewChild('marketProductAddModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-md', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };

  @ViewChild(NgxImageGalleryComponent, {static: true}) ngxImageGallery: NgxImageGalleryComponent;
  images: GALLERY_IMAGE[] = [];
  conf: GALLERY_CONF = {
    imageBorderRadius: '3px',
    imageOffset: '20px',
    showDeleteControl: false,
    showCloseControl: true,
    showExtUrlControl: true,
    showImageTitle: true,
    showThumbnails: true,
    closeOnEsc: true,
    reactToKeyboard: true,
    reactToMouseWheel: true,
    reactToRightClick: false,
    thumbnailSize: 30,
    backdropColor: 'rgba(13,13,14,0.85)',
    inline: false,
    showArrows: true,
    imagePointer: true
  };

  title = "";
  store: any = {};
  callback: Function;
  productModel: any = {};
  errorMsg = '';
  categorys: any = [];
  maxImage = 10;
  isHide = false;
  isShow = false;

  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
    private api: ApiService,
    private mkp: MarketplaceService,
    private ngxLoading: NgxUiLoaderService,
    private coreTranslate: CoreTranslateService
  ) { }

  ngOnInit() {
    this.modalServ.onMarketProductAdd.subscribe(req => {
      this.title = this.coreTranslate.getWord('PRODUCT.ADD_PRODUCT');
      this.productModel = {};
      this.getMyStore(req.id);
      this.callback = req.callback;
      this.getMarketPlaceCategory();
      if(!this.isShow) {this.show();}
      
    });

    this.modalServ.onMarketProductAddHide.subscribe(req => {
      this.hide();
    });
  }

  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
  }

  async getMyStore(id: any) {
    this.store = await this.mkp.getMerchantInfo(id);
  }

  addProduct() {
    if(!this.validation()) return;
    this.ngxLoading.start();
    this.api.marketPlaceCrateProduct(this.productModel).subscribe(res => {
      if (res.Code == 200) {
        this.callback({status: 'success'});
      } else {
        this.callback({status: 'fail'});
      }
      this.hide();
      this.ngxLoading.stopAll();
    }, err => {
      console.error(err);
      this.callback({status: 'fail'});
      this.ngxLoading.stopAll();
    });
  }

  validation() {
    this.productModel.merchant_id = this.store.MerchantId;
    if (Object.keys(this.productModel).length === 0) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_FILL_ALL_INFORMATION');
      return false;
    } else if(!this.productModel.hasOwnProperty('imageProducts') || this.productModel.imageProducts.length < 1) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_SPECIFY_AT_LEAST_1_PRODUCT_PICTURE');
      return false;
    } else if (!this.productModel.prod_name) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_SPECIFY_PRODUCT_NAME');
      return false;
    } else if (!this.productModel.prod_cat) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_SPECIFY_PRODUCT_TYPE');
      return false;
    } else if ((this.productModel.prod_price || this.productModel.prod_price === 0 ? false : true) || this.productModel.prod_price < 0) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_SPECIFY_PRODUCT_PRICE');
      return false;
    }

    return true;
  }

  fileChangeEvent(event: any) {
    // this.hide();
    // this.isHide = true;
    this.modalServ.onImageCapture.emit({image: event, callback: (res)=>{
      if(res) {
        if(!this.productModel.hasOwnProperty('imageProducts')) {
          this.productModel.imageProducts = [];
        }
        this.productModel.imageProducts.push({Url: res, IsDefault: false});
      }
      // this.modalRef = this.modalService.show();
      // this.isHide = false;
    }});
  }

  validateMoney(value: any) {
    let pattern = /[0-9]/g;
    let w = pattern.test(value.value);
    if(!w) {
      value.value = null;
    }
  }

  getMarketPlaceCategory() {
    this.api.getMarketPlaceCategory(false).subscribe(res => {
      if (res.Code == 200) {
        this.categorys = res.Results;
      } else {
        console.error(res);
      }
    }, err => {
      console.error(err);
    });
  }

  openEditImage(index: any) {
    // this.hide();
    this.modalServ.onImageCapture.emit({imgFile: this.productModel.imageProducts[index].Url, callback: (res)=>{
      if(res) {
        this.productModel.imageProducts[index] = {Url: res, IsDefault: this.productModel.imageProducts[index].IsDefault};
      }
      // this.modalRef = this.modalService.show(this.modal, this.configmodal);
    }});
  }

  removeImageProduct(index: any) {
    this.productModel.imageProducts.splice(index, 1);
  }

  viewImage(index: any) {
    this.modalServ.onImageViewer.emit({image: this.productModel.imageProducts[index].Url});
  }

  setImageDefulte(img: any) {
    this.productModel.imageProducts.forEach((g: any) => {
      g.IsDefault = false;
    });
    img.IsDefault = true;
  }

}
